<div class="header">
  <h4 mat-dialog-title>Info</h4>
</div>
<div mat-dialog-content>
  You have already logged into this account on another browser tab. Kindly revert to the original login tab.</div>
<div mat-dialog-actions>
</div>